/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const GetWorkbenchDestinationHealthParams = zod.object({
	start: zod.string(),
	end: zod.string()
});

export type GetWorkbenchDestinationHealthParams = zod.input<
	typeof GetWorkbenchDestinationHealthParams
>;
export type GetWorkbenchDestinationHealthParamsOutput = zod.output<
	typeof GetWorkbenchDestinationHealthParams
>;
